import { NetworkStatus } from '@cbridge-utils/network';
import { IServerStore, ServerType } from './server.interface';

export const serverInitialState: IServerStore = {
  data: {},
  listNetworkStatus: NetworkStatus.None,
};

export const SERVER_TYPE_LABEL_KEY = {
  [ServerType.MT4]: 'text:entity.tradingServer.type.value.mt4',
  [ServerType.MT5]: 'text:entity.tradingServer.type.value.mt5',
  [ServerType.cTrader]: 'text:entity.tradingServer.type.value.cTrader',
  [ServerType.FixTaker]: 'text:entity.tradingServer.type.value.fixTaker',
} as const satisfies Record<ServerType, string>;
